import { KEYBOARD_KEYS } from 'common/constants/keyboard'

export const isValidKeyCode = (keyCode, key) =>
    (keyCode >= 65 && keyCode <= 90) ||
    key.toLowerCase() !== key.toUpperCase() ||
    [KEYBOARD_KEYS.BACKSPACE, KEYBOARD_KEYS.ARROW_RIGHT, KEYBOARD_KEYS.ARROW_LEFT, KEYBOARD_KEYS.DASH].includes(key)
